import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import Topheader from "./Topheader";
import Drivepanel from './Drivepanel';
import Bottomheader from "./Bottomheader";
import { useSelector, useDispatch } from "react-redux";
import * as actionTypes from "../../redux/actionTypes";
import TestCamera from './TestCamera';
import TestDriveSuccess from './TestDriveSuccess';
import SuspiciousActivityModal from '../Modal/SuspiciousActivityModal';
import { getSuspiciousActivity } from '@services/api';
import SupportAgent from '@images/playgame/support_agent.svg';
import { safeLocalStorage } from "@utils/localstorage";
let isSuspiciousActivity = false;

const PlayGame = () => {
  const dispatch = useDispatch();
  const userDetails = safeLocalStorage.getItem("token")
  const user = useSelector((state) => state?.setUserDetails?.user)
  const testDriveComplect = useSelector((state) => state.testDriveDetails.testDriveComplect);
  const keyMapping = useSelector((state) => state?.keyBindings?.keyMapping)
  const suspiciousActivityModel = useSelector((state) => state.loadingSpinner.suspiciousActivityModel);
  const testDriveRideId = useSelector((state) => state.testDriveDetails.testDriveRideId);
  const [suspiciousActivityData, setSupiciousActivityData] = useState();
  const [botPausedActivity, setBotPausedActivity] = useState(false);

  useEffect(() => {
    const suspiciousInterval = setInterval(async () => {
      if (testDriveRideId && !isSuspiciousActivity) {
        const getSuspiciousActivityResponce = await getSuspiciousActivity(testDriveRideId);
        if (getSuspiciousActivityResponce && getSuspiciousActivityResponce?.event_type === 'supersede') {
          setSupiciousActivityData(getSuspiciousActivityResponce);
          dispatch({
            type: actionTypes.SUSPICIOUS_ACTIVITY_MODEL,
            payload: true
          });
          clearInterval(suspiciousInterval);
          isSuspiciousActivity = true;
        } else if (getSuspiciousActivityResponce && getSuspiciousActivityResponce?.error) {
          dispatch({
            type: actionTypes.SUSPICIOUS_ACTIVITY_MODEL,
            payload: false
          });
        } else if (getSuspiciousActivityResponce && getSuspiciousActivityResponce?.event_type === 'pause') {
          setBotPausedActivity(true)
        } else if (getSuspiciousActivityResponce && getSuspiciousActivityResponce?.event_type === 'resume') {
          setBotPausedActivity(false);
        }
      }
    }, 15000);
    return () => {
      clearInterval(suspiciousInterval);
    };
  }, [testDriveRideId]);

  useEffect(() => {
    if (user?.id) {
      const keyMappingLocalStorage = safeLocalStorage.getItem(`keyBinding_${user?.id}`)
      if (keyMappingLocalStorage) {
        dispatch({
          type: actionTypes.KEY_MAPPING_BUTTON,
          payload: keyMappingLocalStorage,
        });
      } else {
        safeLocalStorage.setItem(`keyBinding_${user?.id}`, keyMapping)
      }
    }
  }, [user])

  const interComHandler = () => {
    if (window.Intercom) {
      window.Intercom('show')
    }
  }

  if (!userDetails) {
    return <></>;
  }

  return (
    <>
      <div className="new_testgame_container">
        <TestCamera />
        <div className="testgame_playing_container">
          <Topheader />
          <Drivepanel />
          <Bottomheader />
        </div>
        {
          botPausedActivity &&
          <div className="absolute top-[10%] left-[50%] -translate-x-1/2 w-[620px]">
            <div className="flex p-[12px] items-center gap-[13px] rounded-[24px] border-[2px] border-solid border-[#737373] bg-[#FCF552]">
              <div className="flex items-center gap-[8px]">
                <img src={SupportAgent} alt="Support Agent" className="w-[24px] h-[24px]" />
                <p className="text-[#000] text-[14px] not-italic font-medium leading-[normal] tracking-[-0.56px]">
                  <spna className='text-[#FF1053]'>Driving paused by admin.</spna>{' '}
                  For further instructions,{' '}
                  <button className='text-[#FF1053]' onClick={interComHandler}>please click here to open Intercom.</button>{' '}
                  Provided Reason:{' '}
                  <span className='text-[#FF1053]'>Unsafe Driving</span>
                </p>
              </div>
            </div>
          </div>
        }
      </div>
      <Modal
        isOpen={testDriveComplect}
        ariaHideApp={false}
        className="mymodal"
      >
        <TestDriveSuccess />
      </Modal>
      <Modal
        isOpen={suspiciousActivityModel}
        ariaHideApp={false}
        className="mymodal"
      >
        <SuspiciousActivityModal suspiciousActivityData={suspiciousActivityData} />
      </Modal>
    </>
  );
};

export default PlayGame;
